import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuditFilters, AuditLogItem, AuditAction, AuditResource } from './models/audit-log.model';

export const AuditLogsActions = createActionGroup({
  source: 'Audit Logs',
  events: {
    'Load Requested': emptyProps(),
    'Load Succeeded': props<{ logs: AuditLogItem[] }>(),
    'Load Failed': props<{ error: unknown }>(),

    'Set Search': props<{ search: string }>(),
    'Set Action Filter': props<{ action: 'all' | AuditAction }>(),
    'Set Resource Filter': props<{ resource: 'all' | AuditResource }>(),
    'Clear Filters': emptyProps(),
    Clear: emptyProps(),
  },
});
